export default __webpack_public_path__ + "static/media/bk.15e6b1d6.png";